import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AiChatMessage, AiPromptAudit } from '../../models/ai-assistant.models';
import { AiMessageShellComponent } from '../ai-message-shell/ai-message-shell.component';
import { AGENTS } from '../ai-welcome-state/ai-welcome-state.component';

export interface AiListItem {
  kind: 'message' | 'agent-switch';
  message?: AiChatMessage;
  agentId?: string;
  agentName?: string;
  agentColor?: string;
  agentIcon?: string;
  resolvedAgentName?: string;
}

@Component({
  selector: 'app-ai-message-list',
  standalone: true,
  imports: [CommonModule, AiMessageShellComponent],
  templateUrl: './ai-message-list.component.html',
  styleUrl: './ai-message-list.component.css',
})
export class AiMessageListComponent {
  @Input() messages: AiChatMessage[] = [];
  @Output() auditRequested = new EventEmitter<AiPromptAudit>();
  @Output() followUpSelected = new EventEmitter<string>();

  get listItems(): AiListItem[] {
    const items: AiListItem[] = [];
    let lastAgentId: string | undefined;
    let lastAgentName: string | undefined;

    for (const msg of this.messages) {
      if (msg.role === 'user' && msg.agentId && msg.agentId !== lastAgentId) {
        if (items.length > 0) {
          items.push({
            kind: 'agent-switch',
            agentId: msg.agentId,
            agentName: msg.agentName,
            agentColor: msg.agentColor,
            agentIcon: msg.agentIcon,
          });
        }
        lastAgentId = msg.agentId;
        lastAgentName = msg.agentName;
      }
      items.push({ kind: 'message', message: msg, resolvedAgentName: lastAgentName });
    }

    return items;
  }

  getAgentSvg(icon: string): string {
    const agent = AGENTS.find(a => a.icon === icon);
    const paths: Record<string, string> = {
      shield: 'M12 2l7 4v5c0 5-3.5 9.7-7 11C8.5 20.7 5 16 5 11V6l7-4z',
      layers: 'M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5',
      chart: 'M3 3v18h18M7 16l4-4 4 4 4-8',
      verify: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z',
      email: 'M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z',
      supply: 'M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0',
      attack: 'M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z',
    };
    return paths[icon] ?? paths['shield'];
  }

  trackByItem(_: number, item: AiListItem): string {
    return item.message?.id ?? `switch-${item.agentId}`;
  }
}
